import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { StateManagementService } from 'src/app/shared/services/state-management.service';

import { PageName } from 'src/app/shared/utils/user-roles';
import { IUser } from '../../user-management-interfaces';

import { IUserGroup, IUserGroups } from '../add-user-management.interface';
import { Utility } from 'src/app/shared/utils/utility.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { UserTypeRequest } from 'src/app/shared/constants/request-mapping';
import { userTypeResponse } from 'src/app/shared/constants/response-mapping';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-type',
  templateUrl: './user-type.component.html',
  styleUrls: ['./user-type.component.scss'],
})
export class UserTypeComponent implements OnInit, AfterViewInit {
  @Input() formGroupName!: string;
  @Input() dialogRef?: any;
  formGroup!: FormGroup;
  submited = false;
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  flag = false;
  @Input() skipStepBuilding: boolean = false;
  @Output() skipStepBuildingChange = new EventEmitter<boolean>();
  @Input() flowType!: string;
  @ViewChild('userType') userType!: ElementRef;

  user: IUser | undefined;
  readonly LANG_CONST = LANG_CONST;
  readonly userTypeRequest = UserTypeRequest;
  sharedData?: ISharedData;
  commonAccessControl!: boolean

  readonly addUser = {
    user_type_component: 3,
    access_detail_email_component: 6,
    access_detail_email_comp: 5
  };
  CONSTANTS = CONSTANTS;
  navigateFlag = false;
  unitdata: any;
  unitFlag: boolean = false;
  radionButtons: IUserGroups = [
    {
      label: this.translateService.instant('PROPERTY_MANAGER_ADMIN'),
      name: 'group',
      value: 1,
      desc: this.translateService.instant('DESCRIPTION_PROPERTY_MANAGER_ADMIN'),
      active: false,
      disabled: false,
    },
    {
      label: this.translateService.instant('PROPERTY_MANAGER_USER'),
      name: 'group',
      value: 2,
      desc: this.translateService.instant('DESCRIPTION_PROPERTY_MANAGER_USER'),
      active: false,
      disabled: false,
    },
    {
      label: this.translateService.instant('INSTALLER_ADMIN'),
      name: 'group',
      value: 3,
      desc: this.translateService.instant('DESCRIPTION_INSTALLER_ADMIN'),
      active: false,
      disabled: false,
    },
    {
      label: this.translateService.instant('INSTALLER_USER'),
      name: 'group',
      value: 4,
      desc: this.translateService.instant('DESCRIPTION_INSTALLER_USER'),
      active: false,
      disabled: false,
    },
    {
      label: this.translateService.instant('RESIDENT_ADMIN'),
      name: 'group',
      value: 5,
      desc: this.translateService.instant('DESCRIPTION_RESIDENT_ADMIN'),
      active: false,
      disabled: false,
    },
    {
      label: this.translateService.instant('RESIDENT'),
      name: 'group',
      value: 6,
      desc: this.translateService.instant('DESCRIPTION_RESIDENT'),
      active: false,
      disabled: false,
    },
  ];
  formGroupUserDetail!: FormGroup;
  formGroupEmail!: FormGroup;
  constructor(
    private rootFormGroup: FormGroupDirective,
    public stateManagementService: StateManagementService,
    public sharedDataService: SharedDataService,
    private localizationService: LocalizationService,
    private translateService: TranslateService
  ) {}

  get formInstance() {
    return this.formGroup.controls;
  }
  /**
   * @description this is onInit life cycle method
   * get formgroup from parent with the help of formgroupdirective
   * @returns void
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.sharedDataService.unitData.subscribe({
      next: (v: boolean) => (this.unitFlag = v),
    });
    this.commonAccessControl = this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl;
    this.user = this.stateManagementService.getUser();
    if (this.unitFlag || this.user.userType! === userTypeResponse[2]) {
      this.radionButtons = [
        {
          label: this.translateService.instant('INSTALLER_ADMIN'),
          name: 'group',
          value: 3,
          desc: this.translateService.instant('DESCRIPTION_INSTALLER_ADMIN'),
          active: false,
          disabled: false,
        },
        {
          label: this.translateService.instant('INSTALLER_USER'),
          name: 'group',
          value: 4,
          desc: this.translateService.instant('DESCRIPTION_INSTALLER_USER'),
          active: false,
          disabled: false,
        },
        {
          label: this.translateService.instant('RESIDENT_ADMIN'),
          name: 'group',
          value: 5,
          desc: this.translateService.instant('DESCRIPTION_RESIDENT_ADMIN'),
          active: false,
          disabled: false,
        },
        {
          label: this.translateService.instant('RESIDENT'),
          name: 'group',
          value: 6,
          desc: this.translateService.instant('DESCRIPTION_RESIDENT'),
          active: false,
          disabled: false,
        },
      ];
    }

    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.formGroupUserDetail = this.rootFormGroup.control.get(
      'userDetails'
    ) as FormGroup;
    this.formGroupEmail = this.rootFormGroup.control.get('Email') as FormGroup;
    this.radionButtons!.map((userGroup: IUserGroup) => {
      if (userGroup.value === this.formInstance?.userType.value) {
        userGroup.active = true;
      }
    });
    if (this.rootFormGroup.control?.value?.Email?.existingUserId !== '') {
      this.radionButtons?.map((userGroup: IUserGroup) => {
        userGroup.disabled = true;
      });

      const selectedUserType = this.rootFormGroup.control.get(
        'userTypes'
      ) as FormGroup;
      if (
        this.unitFlag &&
        selectedUserType?.value?.userType ===
          UserTypeRequest[CONSTANTS.PROPERTY_MANAGER_ADMIN]
      ) {
        this.radionButtons?.unshift({
          label: this.translateService.instant('PROPERTY_MANAGER_ADMIN'),
          name: 'group',
          value: 1,
          desc: this.translateService.instant('DESCRIPTION_PROPERTY_MANAGER_ADMIN'),
          type: 'Property_Manager_Admin',
          active: true,
          disabled: false,
        });
      } else if (
        this.unitFlag &&
        selectedUserType?.value?.userType ===
          UserTypeRequest[CONSTANTS.PROPERTY_MANAGER_USER]
      ) {
        this.radionButtons?.unshift({
          label: this.translateService.instant('PROPERTY_MANAGER_USER'),
          name: 'group',
          value: 2,
          desc: this.translateService.instant('DESCRIPTION_PROPERTY_MANAGER_USER'),
          type: 'Property_Manager_User',
          active: true,
          disabled: false,
        });
      }
    }
    if (
      this.formGroupUserDetail?.controls?.firstName?.status ===
      CONSTANTS.DISABLED.toUpperCase()
    ) {
      this.radionButtons?.map((userGroup: IUserGroup) => {
        if (
          userTypeResponse[userGroup.value].includes(CONSTANTS.RESIDENT) &&
          userTypeResponse[this.formGroup.get('userType')?.value].includes(
            CONSTANTS.RESIDENT
          )
        ) {
          userGroup.disabled = false;
        } else {
          userGroup.disabled = true;
        }
      });
    }
  }
  /**
   * @description checking if the UserType coming from API is active then submit function runs
   */
  validatedUserType() {
    const userGroup = this.radionButtons?.find(
      (x: IUserGroup) => x.active === true
    );
    if (userGroup) {
      this.submit();
    }
  }

  /**
   * @description current selected group index mark as active status
   * @param userGroup active number
   */
  activate(userGroup: IUserGroup): void {
    if (!userGroup.disabled) {
      this.radionButtons?.map((x: IUserGroup) => {
        x.active = false;
        userGroup.active = true;
        this.formGroup.get('userType')?.setValue(userGroup.value);
      });
    }

    if (
      userGroup.value === UserTypeRequest[CONSTANTS.PROPERTY_MANAGER_ADMIN] ||
      userGroup.value === UserTypeRequest[CONSTANTS.PROPERTY_MANAGER_USER]
    ) {
      this.skipStepBuildingChange.emit((this.skipStepBuilding = true));
    } else {
      this.skipStepBuildingChange.emit((this.skipStepBuilding = false));
    }
  }

  /**
   * @description navigate to back stepper
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper += -1));
  }

  /**
   * @description validate from if form valid redirect to next step
   * @returns void
   */
  submit(): void {
    this.flag = false;
    if (this.formGroup.invalid) return;

    if (
      CONSTANTS.VALID_WEB_ROLES.includes(
        userTypeResponse[this.formGroup.controls.userType.value]
      ) &&
      this.flowType === CONSTANTS.ADD_USER && this.commonAccessControl
    ) {
      this.stepperChange.emit(
        (this.stepper = this.addUser.access_detail_email_component)
      );
    } else if(  CONSTANTS.VALID_WEB_ROLES.includes(
      userTypeResponse[this.formGroup.controls.userType.value]
    ) &&
    this.flowType === CONSTANTS.ADD_USER && !this.commonAccessControl){
      this.stepperChange.emit(
        (this.stepper = this.addUser.access_detail_email_comp)
      );
    }else {
      this.stepperChange.emit(
        (this.stepper = this.addUser.user_type_component)
      );
    }
  }
  ngAfterViewInit(): void {
    if (this.userType) {
      this.userType.nativeElement.focus();
    }
  }
}
